module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10201.64b1f90b.jpg";